module.exports = __webpack_public_path__ + "static/media/2a_background.4112090a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/2a_background.png
// module id = 2469
// module chunks = 0